export const IMAGE_RATIOS = {
  HOME_HERO: "1440/540",
  HOME_HERO_MOBILE: "320/475",
  HOME_PROMO: "740/320",
  HOME_PROMO_MOBILE: "290/350",
  HOME_PROMO_FOOTER_THIN: "455/320",
  HOME_PROMO_FOOTER_LARGE: "930/320",
  PRODUCT_LIST: "290/320",
  PRODUCT_PAGE: "635/700",
  PRODUCT_PAGE_MOBILE: "320/355",
  CATEGORY: "970/390",
  CATEGORY_MOBILE: "290/505",
  MENU: "360/520",
  SWATCH: "36/36",
  OPERATION: "50/35",
};
